/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface ClosePopupProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const ClosePopup: React.SFC<ClosePopupProps> = ({size, ...props}) => (
  <svg viewBox="0 0 11 11" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M1.06 1.06l9.09 9.09M1.06 10.15c.568-.586 3.598-3.616 9.09-9.09" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" />
  </svg>
);
ClosePopup.displayName = 'ClosePopup';
export default ClosePopup;
/* tslint:enable */
/* eslint-enable */
